import React from 'react';
import ConfirmationModal from './ConfirmationModal';
import { BlueButton, FlexContainer } from '@mindmemobile/mm-shared-global';
import LockImage from '../../../../images/common/lock.svg';
import styled from 'styled-components';
import { observer } from 'mobx-react';

const DarkOrangeSpan = styled.span`
  color: #ff5900;
`;

interface IProps {
  showPopup: boolean;
  title?: string;
  message: string;
  isMyLibrary?: boolean;
  isSharedLibrary?: boolean;
  togglePermissionPopup: (showPopup: boolean) => void;
}

const NoPermissionDialog: React.FC<IProps> = ({
  showPopup = false,
  title = 'Insufficient Rights to Perform this Action',
  message = 'No Message',
  isMyLibrary = false,
  isSharedLibrary = false,
  togglePermissionPopup,
}) => {
  if (!showPopup) return null;

  return (
    <ConfirmationModal
      title={title}
      onClose={() => togglePermissionPopup(false)}
      footerContent={<BlueButton onClick={() => togglePermissionPopup(false)}>Close</BlueButton>}
      body={
        <FlexContainer fxLayout="column" alignItems="center" padding="20px 0px 20px 0px">
          <img src={LockImage} />
          <div className="margin-top-30">
            {isMyLibrary ? (
              <>You cannot modify items in this Library. You must set <DarkOrangeSpan>{message}</DarkOrangeSpan> rights in User Settings.</>
            ) : isSharedLibrary ? (
              <>
                You cannot modify items in this Library. You must set <DarkOrangeSpan>{message}</DarkOrangeSpan> rights in User Settings and enable
                edit rights in Shared Library Settings.
              </>
            ) : (
              <>
                You do not have the required permissions to{' '}
                {message === 'Manage' ? (
                  <>
                    <DarkOrangeSpan>Manage</DarkOrangeSpan> this account.
                  </>
                ) : (
                  <>
                    <DarkOrangeSpan>{message}</DarkOrangeSpan> on this account.
                  </>
                )}{' '}
                Please contact an admin to enable the "{message}" rights in the settings.
              </>
            )}
          </div>
        </FlexContainer>
      }
    />
  );
};
export default observer(NoPermissionDialog);
